'use strict';
define('RunBlockMediator',['RunBlockMediatorFactory'], function (RunBlockMediatorFactory) {
    angular
        .module('TVG.RunBlockMediator', [])
        .factory('RunBlockMediatorFactory', RunBlockMediatorFactory);
});
